import * as React from "react";
import { FormattedMessage, InjectedIntlProps, injectIntl } from "react-intl";

import CookieAlert from "../../components/cookie-alert";

const Footer: React.StatelessComponent<InjectedIntlProps> = props => (
  <React.Fragment>
    <div className="login-footer">
      <div className="login-footer__linkContainer">
        <ul>
          <li>
            <a
              className="login-footer__link"
              href={props.intl.formatMessage({
                defaultMessage: "https://www.paragon-software.com/privacy/",
                id: "login-page.footer.privacy-policy.href"
              })}
              target="_blank"
            >
              <FormattedMessage id="login-page.footer.privacy-policy.label" defaultMessage="Privacy Policy" />
            </a>
          </li>
          <li>
            <a
              className="login-footer__link"
              href={props.intl.formatMessage({
                defaultMessage: "https://www.paragon-software.com/about/#contacts",
                id: "login-page.footer.contacts.href"
              })}
              target="_blank"
            >
              <FormattedMessage id="login-page.footer.contacts.label" defaultMessage="Contacts" />
            </a>
          </li>
        </ul>
      </div>
      <CookieAlert />
    </div>
  </React.Fragment>
);

export default injectIntl(Footer);



// WEBPACK FOOTER //
// ./src/scenes/login-page/footer.tsx